import axios from 'axios'

export function fetchData(sid,rollup,functie,from,to) {
    return function (dispatch) {
        dispatch({type:'FETCH_READINGS_START'});
        axios.get("devices/1614/readings",
            {
                params: {
                    sensor_id: sid,
                    rollup: rollup,
                    function: functie,
                    from: from,
                    to:to
                },
                baseURL: 'https://api.smartcitizen.me/v0',
                headers: {'X-Requested-With': 'XMLHttpRequest'}
            }
        )
        .then ((response) => {
            dispatch({type:'RECEIVE_READINGS', payload:response.data})
        })
        .catch ((err) => {
            dispatch({type:'FETCH_READINGS_ERR',payload:err})
        })
    }
}

export function setSensor(id) {
    return {
        type: 'SET_SENSOR',
        payload: id
    }
}

export function setRollUp(interval) {
    return {
        type: 'SET_ROLLUP',
        payload: interval
    }
}

export function setFunction(type) {
    return {
        type: 'SET_FUNCTION',
        payload: type
    }
}

export function setFromDate(day) {
    return {
        type: 'SET_FROM_DATE',
        payload: day
    }
}

export function setToDate(day) {
    return {
        type: 'SET_TO_DATE',
        payload: day
    }
}





// WEBPACK FOOTER //
// ./src/actions/scActions.js